import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { beneficialOwnersSchema, generateSchema } from '../shared';

const defaultSchema = {
  enterprise: beneficialOwnersSchema,
};

const customSchemas = {
  [FINANCIAL_PRODUCT.SME]: defaultSchema,
  [FINANCIAL_PRODUCT.ACT_COMMUNITY]: defaultSchema,
};

type CustomSchemaType = typeof customSchemas;

export const beneficialOwnerFormSchema = generateSchema<CustomSchemaType, typeof defaultSchema>({
  customSchemas,
  defaultSchema,
});

export type BeneficialOwnerFormType = z.infer<typeof beneficialOwnerFormSchema>;
